import { useLayoutEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { GuestWelcome } from '../../../components/Guest/GuestWelcome'
import { AuthForm } from '../../../components/Guest/AuthForm'
import { PasswordAuthForm } from '../../../components/Guest/PasswordAuthForm'
import { routesGuest } from '../../../consts'
import { GridForms, GridGuestWelcome, GridMain } from './style'

export const Main = () => {
  useLayoutEffect(() => {
    document.title = 'Главная страница'
  }, [])

  const [formType, setFormType] = useState<'otp' | 'password_auth' | 'reg' | 'restore'>('otp');

  const renderForm = () => {
    switch (formType) {
      case 'otp':
        return <AuthForm onSwitch={setFormType} returnTo={routesGuest.ROOT.path} />
      case 'password_auth':
        return <PasswordAuthForm onSwitch={setFormType} returnTo={routesGuest.ROOT.path} />
      default:
        return null
    }
  }

  return (
    <Grid container gap={9} sx={GridMain}>
      <Grid sx={GridGuestWelcome}>
        <GuestWelcome />
      </Grid>
      <Grid sx={GridForms}>
        {renderForm()}
      </Grid>
    </Grid>
  )
}
